import React from 'react';
import { InitialQuotationTable } from './initial_quotation_table';
import { QuotationInfo } from './quotation_info';

export const InitialQuotationMaker = ({ onTotalChange, onDataChange, details, setDetails, ...props }) => {
  const handleDetailChange = (field, value) => {
    setDetails(prev => ({ ...prev, [field]: value }));
  };

  const handleTotalAmountChange = (amount) => {
    if (onTotalChange) {
      onTotalChange(amount);
    }
  };

  return (
    <div className="w-full h-full flex flex-col mt-4">
      <QuotationInfo details={details} onChange={handleDetailChange} />

      {/* Main Content Area */}
      <div className="flex-1 w-full mt-4">
        <InitialQuotationTable 
          onTotalChange={handleTotalAmountChange} 
          onDataChange={onDataChange} 
          initialRows={props.initialRows}
          initialDiscount={props.initialDiscount}
          initialGst={props.initialGst}
          stockSelections={props.stockSelections}
        />
        
      </div>
    </div>
  );
};
